












import Vue from 'vue';
import URLHelper from '@/helpers/URLHelper';
import config from '../../../config';

interface IProductsOverviewHeadlineComponent {
  headline: string;
  showHeadlineWrapper: boolean;
}

interface ISpecialURLSlugs {
  [index:string]: string[];
}

export default Vue.extend({
  name: `ProductsOverviewHeadline`,
  data(): IProductsOverviewHeadlineComponent {
    return {
      headline: ``,
      showHeadlineWrapper: true,
    };
  },
  mounted(): void {
    const { slug } = URLHelper.parsedUrlObject;
    const specialPageSlugs = config.products.specialShopCategoriesURLSlugs as ISpecialURLSlugs;
    let categoryId = slug;
    for(const group of Object.keys(specialPageSlugs)) {
      categoryId = specialPageSlugs[group].includes(slug) ? group : categoryId;
    }
    const doNotShowInCategories = [`sport`];
    if(doNotShowInCategories.includes(categoryId)) {
      this.showHeadlineWrapper = false;
    }
    const isVoucher = document.querySelector(`body`)?.classList.contains(`page-template-template-voucher`);
    this.headline = isVoucher ? this.$t(`products-overview:category.gutschein.headline`) : this.$t(`products-overview:category.${categoryId}.headline`);
  },
});
